export const CARD_TITLE_MAX_LENGTH = 250;
export const CARD_DESCRIPTION_MAX_LENGTH = 1000;
export const CATEGORY_TITLE_MAX_LENGTH = 128;
